import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';

@Component({
  selector: 'app-rejected-action-items',
  templateUrl: './rejected-action-items.component.html',
  styleUrls: ['./rejected-action-items.component.css']
})
export class RejectedActionItemsComponent implements OnInit {

  isArabic!: boolean;
  rejectedActionPlansForm!: FormGroup;
  rejectedActionPlansList: any;
  selectedActionPlan: any;
  modalRefDeactivate!: BsModalRef;
  actionPlanEvent = new EventEmitter();

  constructor(
    public formBuilder: FormBuilder,
    private actionPlanService: ActionPlanService,
    private commonService: CommonService,
    private modalService: BsModalService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    let userData = this.storageService.getSessionStorageData('userDetails');
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    const rqstBody = {
      assessmentUnitGuid: userData?.assessmentUnitValue,
      isRejected: true
    };
    this.rejectedActionPlansForm = this.formBuilder.group({
      rejectedActionPlan: ['', [Validators.required]]
    });

    this.actionPlanService.getRejectedActionPlans(rqstBody).subscribe((res: any) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        //console.log('get rejected plans list : ', decryptedData);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.rejectedActionPlansList = resp.actionPlans;
        if (this.rejectedActionPlansList.length > 0) {
          // selectedQuestionnaire = this.questionnaireList[0];
          this.rejectedActionPlansForm.controls['rejectedActionPlan'].setValue(this.rejectedActionPlansList[0].actionPlanId);
          this.selectedActionPlan = JSON.stringify(this.rejectedActionPlansList[0]);
          this.actionPlanEvent.emit(this.selectedActionPlan);
        }
      }
    }), (error: any) => {
      //console.log('server error check: ', error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      }
    }
  }


  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  selectActionPlan(evt: any) {
    let actionItemId = evt.target?.value;
    if (actionItemId !== '') {
      let selectedActionItem = this.rejectedActionPlansList.filter((ele: any) => ele?.actionPlanId == actionItemId);
      if (selectedActionItem.length > 0) {
        this.selectedActionPlan = JSON.stringify(selectedActionItem[0]);
        this.actionPlanEvent.emit(this.selectedActionPlan);
      }
    } else {
      this.actionPlanEvent.emit(null);
    }
    //console.log('in pending plan: ', this.selectActionPlan);
  }

}
